import { apiFetch } from "../fetchApi";

export const fetchCandidatess = async (BeURL, filterOptions, setCandidates, setTotalPages, setTotalCandidates, setLoading, setShowSearchOptions, showAlert) => {

    try {
        const ProSearchRes = await apiFetch(`${BeURL}/advance-filter`, {
            method: 'POST',
            body: JSON.stringify(filterOptions)
        });

        const ProSearchData = await ProSearchRes.json();
        setLoading(false)

        if (!ProSearchData.success) {
            showAlert(ProSearchData.message);
            return;
        }

        setCandidates(ProSearchData.candidates)
        setTotalPages(ProSearchData.totalPages)
        setTotalCandidates(ProSearchData.totalCandidates)

        // if (ProSearchData.pipeline) {
        //     console.log("pipeline::", ProSearchData.pipeline)
        // }

    } catch (err) {
        setShowSearchOptions(false)
        setLoading(false)
        console.log("Error in Advance filter functionality:", err)
    }

    // fetch(`${BeURL}`, {

    //     headers: {
    //         'Content-Type': 'application/json',
    //         Accept: 'application/json'
    //     },
    //     credentials: 'include',

    // })
    //     .then(res => res.json())
    //     .then(data => {
    //         console.log(" received advance-filter response:", data)
    //         // setShowSearchOptions(true)

    //         if (data.success) {

    //             // window.location.href="#list-candidates"
    //         }
    //         else { showAlert(data.message) }



    //     })
    //     .catch(err => {
    //         setShowSearchOptions(false)
    //         setLoading(false)
    //         console.log("Error in Advance filter functionality:", err)
    //     })
}

export const fetchNewCandidateProfile = async (qs, ctrl, setPagination, setNewUsers, BeURL, showAlert, setLoading, filters) => {


    try {
        setLoading(true);


        const res = await apiFetch(`${BeURL}/get-newuser?${qs}`, {
            credentials: "include",
            signal: ctrl.signal,
        });
        const data = await res.json();
        if (data?.success) {


            setNewUsers(Array.isArray(data.newUsers) ? data.newUsers : []);
            setPagination(
                data.pagination ?? {
                    page: filters.page,
                    perPage: filters.perPage,
                    totalPages: 1,
                    total: Array.isArray(data.newUsers) ? data.newUsers.length : 0,
                }
            );
        }
    } catch (err) {
        console.log("Error in Search functionality:", err)
    }
}

// Fetch Candidate Resume viewer:
export const fetchCandidateResumeViewer = async (BeURL, candidateId, showAlert, setResumePreviewUrl, setResumeBlob) => {
    try {
        const res = await apiFetch(`${BeURL}/fetch-resume-viewer/${candidateId}`, {
            method: "GET",
            credentials: "include"
        });

        if (!res.ok) {
            const errorData = await res.json().catch(() => null);

            showAlert(errorData?.message || "Unable to load resume");
            return;
        }

        const blob = await res.blob();

        if (!blob || blob.size === 0) {
            showAlert("Resume file is empty or unavailable");
            return;
        }

        setResumeBlob(blob);

        const resumeUrl = URL.createObjectURL(blob);

        setResumePreviewUrl(resumeUrl);

    } catch (err) {
        console.log("Error in fetching Candidate resume viewer:", err);
        showAlert("Trouble in connecting to the Server! kindly try again later.");
    }
};
